import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

export const MenuSpacer = () => (
  <Grid item>
    <Typography>•</Typography>
  </Grid>
)
